import { apiV3Typed } from 'Services/api/apiV3';
import { getUserCookieKey } from 'Services/api/utils';
import { makeChunkedRequest } from 'GlobalShared/utils/makeChunkedRequest';

type SubscriptionsT = Record<string, ReadonlyArray<string | number>>;

export const deleteEmailNotifications = function (
  subscriptions: SubscriptionsT,
) {
  return makeChunkedRequest((chunkedSubscriptions) => {
    return apiV3Typed.delete('account/{cookie_key}/subscriptions', {
      path: {
        cookie_key: getUserCookieKey(),
      },
      body: {
        subscriptions: chunkedSubscriptions,
      },
    });
  }, subscriptions) as any;
};
